var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_828_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 4.125C11 3.76033 10.8551 3.41059 10.5973 3.15273C10.3394 2.89487 9.98967 2.75 9.625 2.75H8.70833V0H2.29167V2.75H1.375C1.01033 2.75 0.660591 2.89487 0.402728 3.15273C0.144866 3.41059 0 3.76033 0 4.125L0 9.625H2.29167V11H8.70833V9.625H11V4.125ZM3.20833 0.916667H7.79167V2.75H3.20833V0.916667ZM7.79167 10.0833H3.20833V7.33333H7.79167V10.0833ZM10.0833 8.70833H8.70833V6.41667H2.29167V8.70833H0.916667V4.125C0.916667 4.00344 0.964955 3.88686 1.05091 3.80091C1.13686 3.71496 1.25344 3.66667 1.375 3.66667H9.625C9.74656 3.66667 9.86314 3.71496 9.94909 3.80091C10.035 3.88686 10.0833 4.00344 10.0833 4.125V8.70833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70833 4.58333H6.875V5.49999H8.70833V4.58333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_828_527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterSelected);
export default __webpack_public_path__ + "static/media/PrinterSelected.3da33e66d0e876f63af9c9263a1ea49c.svg";
export { ForwardRef as ReactComponent };